<ng-template let-row="row" let-value="value">
    <div class="d-flex align-items-center">
        <div class="switch-cell-button">
            <app-switch [isActive]="value.status === statuses.Active"></app-switch>
        </div>
        <span>{{value.textValue}}</span>
    </div>
</ng-template>
